window.addEventListener('scroll', function() {
  var seal = document.getElementById('ra-verified-seal');
  var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

  if (scrollTop > 100) {  
    seal.style.opacity = 0; 
    seal.style.transform = 'scale(0.5)';  
  } else {
    seal.style.opacity = 1; 
    seal.style.transform = 'scale(1)';  
  }
});
